"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var vue_2 = require("vue");
var _hoisted_1 = {
    key: 0,
    class: "modal-overlay eh-popup-overlay"
};
var _hoisted_2 = { class: "modal-body" };
var _hoisted_3 = { class: "form-row" };
var _hoisted_4 = { class: "form-group" };
var _hoisted_5 = { class: "form-group" };
var _hoisted_6 = { class: "form-row" };
var _hoisted_7 = { class: "form-group" };
var _hoisted_8 = { class: "form-row" };
var _hoisted_9 = { class: "form-group" };
var _hoisted_10 = { class: "form-row" };
var _hoisted_11 = { class: "form-group" };
var _hoisted_12 = { class: "form-group" };
var _hoisted_13 = { class: "form-row" };
var _hoisted_14 = { class: "form-group" };
var _hoisted_15 = { class: "form-row" };
var _hoisted_16 = { class: "form-group" };
var _hoisted_17 = { class: "form-group" };
var _hoisted_18 = { class: "form-row" };
var _hoisted_19 = { class: "form-group" };
var _hoisted_20 = { class: "form-group" };
var _hoisted_21 = { class: "modal-footer" };
var _hoisted_22 = ["disabled"];
var vue_3 = require("vue");
var providerCardsStore_1 = require("../../../stores/providerCardsStore"); // use provider store if different
exports.default = (0, vue_1.defineComponent)({
    __name: 'ProviderEditModal',
    props: {
        show: { type: Boolean },
        patprovider: {}
    },
    emits: ["close", "saved"],
    setup: function (__props, _a) {
        var __emit = _a.emit;
        var props = __props;
        var emit = __emit;
        var store = (0, providerCardsStore_1.useProviderCardsStore)();
        var modalRef = (0, vue_3.ref)(null);
        var saving = (0, vue_3.ref)(false);
        var position = (0, vue_3.reactive)({ x: 100, y: 100 });
        var dragOffset = (0, vue_3.reactive)({ x: 0, y: 0 });
        var isDragging = (0, vue_3.ref)(false);
        var form = (0, vue_3.ref)({
            id: '',
            firstName: '',
            lastName: '',
            npi: '',
            address: '',
            city: '',
            state: '',
            zip: '',
            tel: '',
            cell: '',
            fax: '',
            email: ''
        });
        // populate and center when opened
        (0, vue_3.watch)(function () { return props.show; }, function (show) {
            var _a;
            if (show && typeof window !== 'undefined') {
                position.x = Math.max(50, (window.innerWidth - 500) / 2);
                position.y = Math.max(30, (window.innerHeight - 600) / 2);
                if (props.patprovider) {
                    console.log("Provider props - Show me the moenty");
                    console.log(props.patprovider);
                    form.value = {
                        id: props.patprovider.id || '',
                        firstName: props.patprovider.firstName || '',
                        lastName: props.patprovider.lastName || '',
                        npi: props.patprovider.npinumber || props.patprovider.npinumber || '',
                        address: (_a = props.patprovider.address) === null || _a === void 0 ? void 0 : _a.street,
                        city: props.patprovider.address.city,
                        state: props.patprovider.address.state,
                        zip: props.patprovider.address.zip,
                        tel: props.patprovider.phone || '',
                        cell: props.patprovider.mobile || '',
                        fax: props.patprovider.fax || '',
                        email: props.patprovider.email || ''
                    };
                }
            }
        });
        function startDrag(e) {
            isDragging.value = true;
            var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
            var clientY = 'touches' in e ? e.touches[0].clientY : e.clientY;
            dragOffset.x = clientX - position.x;
            dragOffset.y = clientY - position.y;
            document.addEventListener('mousemove', onDrag);
            document.addEventListener('mouseup', stopDrag);
            document.addEventListener('touchmove', onDrag);
            document.addEventListener('touchend', stopDrag);
        }
        function onDrag(e) {
            if (!isDragging.value)
                return;
            var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
            var clientY = 'touches' in e ? e.touches[0].clientY : e.clientY;
            position.x = Math.max(0, Math.min(clientX - dragOffset.x, window.innerWidth - 400));
            position.y = Math.max(0, Math.min(clientY - dragOffset.y, window.innerHeight - 100));
        }
        function stopDrag() {
            isDragging.value = false;
            document.removeEventListener('mousemove', onDrag);
            document.removeEventListener('mouseup', stopDrag);
            document.removeEventListener('touchmove', onDrag);
            document.removeEventListener('touchend', stopDrag);
        }
        function handleSave() {
            return __awaiter(this, void 0, void 0, function () {
                var ok;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!props.patprovider || saving.value)
                                return [2 /*return*/];
                            saving.value = true;
                            return [4 /*yield*/, store.axiosUpdateProvider(form.value.id, {
                                    firstName: form.value.firstName,
                                    lastName: form.value.lastName,
                                    npinumber: form.value.npi,
                                    address: {
                                        street: form.value.address,
                                        street2: '',
                                        city: form.value.city,
                                        state: form.value.state,
                                        zip: form.value.zip
                                    },
                                    phone: form.value.tel,
                                    mobile: form.value.cell,
                                    fax: form.value.fax,
                                    email: form.value.email
                                })];
                        case 1:
                            ok = _a.sent();
                            saving.value = false;
                            if (!ok) {
                                alert('Could not save changes. Please try again.');
                                return [2 /*return*/];
                            }
                            emit('saved');
                            emit('close');
                            return [2 /*return*/];
                    }
                });
            });
        }
        (0, vue_3.onUnmounted)(function () {
            document.removeEventListener('mousemove', onDrag);
            document.removeEventListener('mouseup', stopDrag);
            document.removeEventListener('touchmove', onDrag);
            document.removeEventListener('touchend', stopDrag);
        });
        return function (_ctx, _cache) {
            return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(vue_2.Teleport, { to: "body" }, [
                (0, vue_2.createVNode)(vue_2.Transition, { name: "modal" }, {
                    default: (0, vue_2.withCtx)(function () { return [
                        (_ctx.show)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                                (0, vue_2.createElementVNode)("div", {
                                    ref_key: "modalRef",
                                    ref: modalRef,
                                    class: "edit-modal eh-popup-panel",
                                    style: (0, vue_2.normalizeStyle)({ left: position.x + 'px', top: position.y + 'px' })
                                }, [
                                    (0, vue_2.createElementVNode)("div", {
                                        class: "modal-header",
                                        onMousedown: startDrag,
                                        onTouchstart: startDrag
                                    }, [
                                        _cache[14] || (_cache[14] = (0, vue_2.createElementVNode)("div", { class: "header-left" }, [
                                            (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-user" }),
                                            (0, vue_2.createElementVNode)("h3", null, "Edit Provider")
                                        ], -1)),
                                        (0, vue_2.createElementVNode)("button", {
                                            class: "close-btn",
                                            onClick: _cache[0] || (_cache[0] = function ($event) { return (_ctx.$emit('close')); })
                                        }, __spreadArray([], (_cache[13] || (_cache[13] = [
                                            (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-remove bi-x-lg" }, null, -1)
                                        ])), true))
                                    ], 32),
                                    (0, vue_2.createElementVNode)("div", _hoisted_2, [
                                        (0, vue_2.createElementVNode)("form", {
                                            onSubmit: (0, vue_2.withModifiers)(handleSave, ["prevent"])
                                        }, [
                                            (0, vue_2.createElementVNode)("div", _hoisted_3, [
                                                (0, vue_2.createElementVNode)("div", _hoisted_4, [
                                                    _cache[15] || (_cache[15] = (0, vue_2.createElementVNode)("label", null, "First Name", -1)),
                                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) { return ((form.value.firstName) = $event); }),
                                                        type: "text"
                                                    }, null, 512), [
                                                        [vue_2.vModelText, form.value.firstName]
                                                    ])
                                                ]),
                                                (0, vue_2.createElementVNode)("div", _hoisted_5, [
                                                    _cache[16] || (_cache[16] = (0, vue_2.createElementVNode)("label", null, "Last Name", -1)),
                                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) { return ((form.value.lastName) = $event); }),
                                                        type: "text"
                                                    }, null, 512), [
                                                        [vue_2.vModelText, form.value.lastName]
                                                    ])
                                                ])
                                            ]),
                                            (0, vue_2.createElementVNode)("div", _hoisted_6, [
                                                (0, vue_2.createElementVNode)("div", _hoisted_7, [
                                                    _cache[17] || (_cache[17] = (0, vue_2.createElementVNode)("label", null, "NPI", -1)),
                                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) { return ((form.value.npi) = $event); }),
                                                        type: "text"
                                                    }, null, 512), [
                                                        [vue_2.vModelText, form.value.npi]
                                                    ])
                                                ])
                                            ]),
                                            (0, vue_2.createElementVNode)("div", _hoisted_8, [
                                                (0, vue_2.createElementVNode)("div", _hoisted_9, [
                                                    _cache[18] || (_cache[18] = (0, vue_2.createElementVNode)("label", null, "Address", -1)),
                                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) { return ((form.value.address) = $event); }),
                                                        type: "text"
                                                    }, null, 512), [
                                                        [vue_2.vModelText, form.value.address]
                                                    ])
                                                ])
                                            ]),
                                            (0, vue_2.createElementVNode)("div", _hoisted_10, [
                                                (0, vue_2.createElementVNode)("div", _hoisted_11, [
                                                    _cache[19] || (_cache[19] = (0, vue_2.createElementVNode)("label", null, "City", -1)),
                                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                        "onUpdate:modelValue": _cache[5] || (_cache[5] = function ($event) { return ((form.value.city) = $event); }),
                                                        type: "text"
                                                    }, null, 512), [
                                                        [vue_2.vModelText, form.value.city]
                                                    ])
                                                ]),
                                                (0, vue_2.createElementVNode)("div", _hoisted_12, [
                                                    _cache[20] || (_cache[20] = (0, vue_2.createElementVNode)("label", null, "State", -1)),
                                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                        "onUpdate:modelValue": _cache[6] || (_cache[6] = function ($event) { return ((form.value.state) = $event); }),
                                                        type: "text"
                                                    }, null, 512), [
                                                        [vue_2.vModelText, form.value.state]
                                                    ])
                                                ])
                                            ]),
                                            (0, vue_2.createElementVNode)("div", _hoisted_13, [
                                                (0, vue_2.createElementVNode)("div", _hoisted_14, [
                                                    _cache[21] || (_cache[21] = (0, vue_2.createElementVNode)("label", null, "Zip", -1)),
                                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                        "onUpdate:modelValue": _cache[7] || (_cache[7] = function ($event) { return ((form.value.zip) = $event); }),
                                                        type: "text"
                                                    }, null, 512), [
                                                        [vue_2.vModelText, form.value.zip]
                                                    ])
                                                ])
                                            ]),
                                            (0, vue_2.createElementVNode)("div", _hoisted_15, [
                                                (0, vue_2.createElementVNode)("div", _hoisted_16, [
                                                    _cache[22] || (_cache[22] = (0, vue_2.createElementVNode)("label", null, "Tel", -1)),
                                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                        "onUpdate:modelValue": _cache[8] || (_cache[8] = function ($event) { return ((form.value.tel) = $event); }),
                                                        type: "tel"
                                                    }, null, 512), [
                                                        [vue_2.vModelText, form.value.tel]
                                                    ])
                                                ]),
                                                (0, vue_2.createElementVNode)("div", _hoisted_17, [
                                                    _cache[23] || (_cache[23] = (0, vue_2.createElementVNode)("label", null, "Cell", -1)),
                                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                        "onUpdate:modelValue": _cache[9] || (_cache[9] = function ($event) { return ((form.value.cell) = $event); }),
                                                        type: "tel"
                                                    }, null, 512), [
                                                        [vue_2.vModelText, form.value.cell]
                                                    ])
                                                ])
                                            ]),
                                            (0, vue_2.createElementVNode)("div", _hoisted_18, [
                                                (0, vue_2.createElementVNode)("div", _hoisted_19, [
                                                    _cache[24] || (_cache[24] = (0, vue_2.createElementVNode)("label", null, "Fax", -1)),
                                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                        "onUpdate:modelValue": _cache[10] || (_cache[10] = function ($event) { return ((form.value.fax) = $event); }),
                                                        type: "tel"
                                                    }, null, 512), [
                                                        [vue_2.vModelText, form.value.fax]
                                                    ])
                                                ]),
                                                (0, vue_2.createElementVNode)("div", _hoisted_20, [
                                                    _cache[25] || (_cache[25] = (0, vue_2.createElementVNode)("label", null, "Email", -1)),
                                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                        "onUpdate:modelValue": _cache[11] || (_cache[11] = function ($event) { return ((form.value.email) = $event); }),
                                                        type: "email",
                                                        disabled: ""
                                                    }, null, 512), [
                                                        [vue_2.vModelText, form.value.email]
                                                    ])
                                                ])
                                            ])
                                        ], 32)
                                    ]),
                                    (0, vue_2.createElementVNode)("div", _hoisted_21, [
                                        (0, vue_2.createElementVNode)("button", {
                                            type: "button",
                                            class: "btn-save",
                                            disabled: saving.value,
                                            onClick: handleSave
                                        }, (0, vue_2.toDisplayString)(saving.value ? 'Saving…' : 'Save'), 9, _hoisted_22),
                                        (0, vue_2.createElementVNode)("button", {
                                            type: "button",
                                            class: "btn-close",
                                            onClick: _cache[12] || (_cache[12] = function ($event) { return (_ctx.$emit('close')); })
                                        }, "Cancel")
                                    ])
                                ], 4)
                            ]))
                            : (0, vue_2.createCommentVNode)("", true)
                    ]; }, undefined, true),
                    _: 1
                })
            ]));
        };
    }
});
